import styled from 'styled-components';
import { Form } from '@unform/web';

export const Formulario = styled(Form)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  width: 95%;

  box-sizing: border-box;

  flex-wrap: wrap;
`;

export const ConteinerTabela = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  width: 100%;
  margin: 1rem 0px;
`;

export const InputsDistribuidos = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Conteiner = styled.div`
  width: 100%;
`;

export const ConteinerModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  padding: 20px 50px;

  #destaqueModal {
    font-weight: 700;
  }
`;
